import { render, staticRenderFns } from "./AddNewWaiter.vue?vue&type=template&id=508454a0&scoped=true"
import script from "./AddNewWaiter.vue?vue&type=script&lang=js"
export * from "./AddNewWaiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508454a0",
  null
  
)

export default component.exports